// Lắc ống quẻ (effect-tayqua) khi bấm Rút Quẻ.
// Đặt độc lập ở đầu file + capture-phase để không bị code khác/lỗi setup làm hỏng,
// và chạy trước handler của thư viện (tránh bị stopPropagation chặn).
(function () {
    var tayquaTimer;
    var onPress = function (e) {
        var t = e.target;
        var btn = t && t.closest ? t.closest(".pm__rut, .MS__sprite-rutque, .rut-1") : null;
        if (!btn) return;
        var effect = document.querySelector(".effect-tayqua");
        if (!effect) return;
        effect.classList.add("shaking");
        clearTimeout(tayquaTimer);
        // Lắc 1s rồi ra popup kết quả.
        tayquaTimer = setTimeout(function () {
            effect.classList.remove("shaking");
        }, 1000);
    };
    document.addEventListener("pointerdown", onPress, true);
    document.addEventListener("click", onPress, true);
})();

window.addEventListener("load", function () {

    var musicUrl = $("#MS__wrapper").data("audio") || $("body").data("audio");
    if (!musicUrl) return;

    var audioElement = $('<audio id="backgroundMusic" loop></audio>');
    audioElement.append('<source src="' + musicUrl + '" type="audio/mpeg">');
    $("body").append(audioElement);

    var audio = document.getElementById("backgroundMusic");
    var hasInteracted = false;
    // $(".btn-music") catch cả nav (PC) lẫn mobile menu (.btn-music corner)
    var $btnMusic = $(".btn-music");
    // .menu-nav__item--amthanh = audio toggle trong mobile menu nav (item thứ 1)
    var $btnAmThanh = $(".menu-nav__item--amthanh");

    var syncBtnState = function () {
        if (audio.paused) {
            // paused → music sprite "off" + amthanh "active" (visual mute)
            $btnMusic.removeClass("MS__sprite-btn-music-on").addClass("MS__sprite-btn-music-off");
            $btnAmThanh.addClass("active");
        } else {
            $btnMusic.removeClass("MS__sprite-btn-music-off").addClass("MS__sprite-btn-music-on");
            $btnAmThanh.removeClass("active");
        }
    };
    audio.addEventListener("play", syncBtnState);
    audio.addEventListener("pause", syncBtnState);
    syncBtnState();

    // Toggle audio — bind cho cả PC nav .btn-music + mobile menu .amthanh
    var toggleAudio = function (e) {
        e.preventDefault();
        hasInteracted = true;
        if (audio.paused) {
            audio.play().catch(function (error) {
                console.log("Audio play error:", error);
            });
        } else {
            audio.pause();
        }
    };

    $btnMusic.on("click", toggleAudio);
    $btnAmThanh.on("click", toggleAudio);

    var autoPlayHandler = function () {
        if (hasInteracted) return;
        hasInteracted = true;
        audio.play().catch(function (error) {
            console.log("Autoplay prevented:", error);
        });
        $(document).off("click touchstart", autoPlayHandler);
    };
    $(document).on("click touchstart", autoPlayHandler);

    document.addEventListener("visibilitychange", function () {
        if (document.hidden) {
            if (!audio.paused) audio.pause();
        } else if (hasInteracted && audio.paused) {
            audio.play().catch(function (error) {
                console.log("Audio resume error:", error);
            });
        }
    });
});

window.addEventListener("load", function () {
    const dndPromotion = window.libraryMainsite.promotion;
    let globalCount;

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            timeWait: 1000,
        },
        animResult: function (listPrize) {
            var displayPrize = listPrize[0];
            // indexWord = key chữ cái của quẻ trúng (A..V), trùng key của namesCustom.
            var prizeKey = displayPrize.indexWord;

            var custom = prodTemplate.namesCustom || {};
            var text1 = (custom.text1 || {})[prizeKey] || "";
            var text2 = (custom.text2 || {})[prizeKey] || "";

            // 2 block trong popup reward: block 1 = "Quẻ", block 2 = "Giải nghĩa".
            var $texts = $("#popup_reward .reward-block .reward-text");
            $texts.eq(0).text(text1);
            $texts.eq(1).text(text2);
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();

        },
    })

});